import { createPlacement } from '@post-office/placement-common-v2';
import { type CustomRenderer } from '@post-office/placement-common-v2/types';
import { type EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';
import { usePlacementApi } from '@post-office/use-placement-api';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { useEffect, useState } from 'react';

export type PlacementRenderProps = {
	/**
	 * Whether the project has a list preference
	 * Used by jira-nin-list-merge-modal-onboarding-v2 message
	 */
	hasListPreference?: boolean;
	/**
	 * Whether the List is in detailed view
	 * Used by jira-nin-list-merge-modal-onboarding-v2 message
	 */
	isDetailedView?: boolean;
	/**
	 * The target background color
	 * Used by jira-nin-list-merge-spotlight-onboarding-v2 message
	 */
	targetBgColor?: string;
	/**
	 * The project name
	 * Used by jira-nin-paid-list-merge-modal-onboarding message
	 */
	projectName?: string;
};

type PlacementDefinition = CustomRenderer<PlacementRenderProps>;

export const { createFrontend, createBackend } = createPlacement<PlacementDefinition>({
	placementId: `issue-navigator-placement`,
	options: {
		choreographer: {
			isDefaultEnabled: true,
		},
	},
});

export const PlacementFrontend = createFrontend<PlacementRenderProps>((Messages) => (appProps) => {
	const { data, error, isLoading } = usePlacementApi<{
		messages: Array<EligibleMessage<Record<string, never>>>;
	}>('/');

	const [messages, setMessages] = useState<EligibleMessage<Record<string, never>>[]>([]);
	useEffect(() => {
		if (isLoading || error) {
			return;
		}
		setMessages(data.messages);
	}, [data, error, isLoading]);

	if (error || isLoading || messages.length === 0) {
		return null;
	}

	return (
		!isLoading && (
			<>
				{messages?.map?.((props) => (
					<Messages.render key={props.messageInstanceId} {...props} {...appProps} />
				))}
			</>
		)
	);
});

export const PlacementBackend = createBackend();
